import Layout from "../Shared/Layout";
import DomainHeader from "./Domains/DomainHeader";
import ListDomains from "./Domains/ListDomains";

const Dashboard = () => {

    return(
        <>
            <Layout>
                <div className="content-body default-height">
                    <DomainHeader/>
                    <div className="container-fluid " style={{display:'flex',flexWrap:'wrap',alignItems:'start'}}>
                        <div className="col-xl-12">
                           <div className="row">
                             <ListDomains/> 
                           </div>
                        </div>    
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Dashboard;